import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/authStore';
import { authService } from '@/shared/services/authService';

export function Header() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { user, clearAuth } = useAuthStore();

  const handleLogout = async () => {
    try {
      await authService.signOut();
      // Clear all cached queries to prevent data leakage to next user
      queryClient.clear();
      clearAuth();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      // Still clear cache and local state even if signOut fails
      queryClient.clear();
      clearAuth();
      navigate('/login');
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-4 sm:px-6 py-4 flex justify-between items-center gap-4">
        <h1 className="text-lg sm:text-xl font-bold text-gray-900 truncate">Frame Replenishment System</h1>
        <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
          <span className="text-xs sm:text-sm text-gray-600 truncate max-w-[120px] sm:max-w-none">{user?.name || 'User'}</span>
          <button
            onClick={handleLogout}
            className="text-xs sm:text-sm text-blue-600 hover:text-blue-800 whitespace-nowrap"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}
